import { createSlice, } from "@reduxjs/toolkit";
import { occyLs } from "../../../utils/localStorage";


const loadState = () => {
    try {
        const stored = occyLs.getItem('vpData');
        if (stored) return JSON.parse(stored);
    } catch (err) {
        console.error("Failed to load video profile from localStorage", err);
    }
    return {
        name: "",
        title: "",
        startDescription: "",
        endDescription: "",
    };
};

const initialState = loadState()

const videoProfileSlice = createSlice({
    name: "videoProfile",
    initialState,
    reducers: {
        saveVideoProfile: (state, action) => {
            const newState = { ...state, ...action.payload };
            occyLs.setItem('vpData', JSON.stringify(newState));
            return newState;
        },

        getVideoProfile: (state) => {
            return state;
        },

        // Reset state
        resetVideoProfile: () => {
            occyLs.removeItem('vpData');
            return {
                name: "",
                title: "",
                startDescription: "",
                endDescription: "",
            };
        },
    },
});

export const { saveVideoProfile, getVideoProfile, resetVideoProfile } =
    videoProfileSlice.actions;

export default videoProfileSlice.reducer;
